import styled from 'styled-components';

export const BannerContainer = styled.section`
  background-color: #0091ff;
  padding: 4rem;
  position: relative;
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 3rem 2rem;
  }
`;

export const BannerContent = styled.div`
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const PersonColumn = styled.div`
  flex: 0.8;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

export const TextColumn = styled.div`
  flex: 1.2;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const MainHeading = styled.h2`
  color: white;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 2rem;
    text-align: center;
  }
`;

export const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 2.5rem 0;
`;

export const BenefitItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const CheckIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 50%;
  color: #0091ff;
  font-size: 1rem;
  margin-right: 0.8rem;
`;

export const BenefitText = styled.span`
  color: white;
  font-size: 1.2rem;
`;

export const ActionButton = styled.button`
  background-color: white;
  color: #0091ff;
  border: none;
  border-radius: 30px;
  font-size: 1.2rem;
  font-weight: 600;
  padding: 0.8rem 3rem;
  cursor: pointer;
  align-self: flex-start;
  transition: all 0.2s;
  
  &:hover {
    background-color: #f0f0f0;
    transform: scale(1.05);
  }
  
  @media (max-width: 768px) {
    align-self: center;
  }
`;

export const PersonImage = styled.img`
  max-height: 450px;
  object-fit: contain;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.1));
`;

export const OrangeCircle = styled.div`
  position: absolute;
  width: 150px;
  height: 150px;
  background-color: rgba(255, 145, 77, 0.7);
  border-radius: 50%;
  right: 10%;
  bottom: -50px;
  z-index: 1;
`;

export const LightBlueShape = styled.div`
  position: absolute;
  width: 180px;
  height: 180px;
  background-color: rgba(96, 183, 255, 0.7);
  border-radius: 40% 60% 70% 30% / 40% 50% 50% 60%;
  right: 5%;
  bottom: -60px;
  z-index: 0;
`;
